// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Device hierarchy level.
 */
export enum DeviceHierarchy {
  PRIMARY = 0,
  SECONDARY = 1,
  CONTROL = 2,
}
